import api from './api';

export interface CalendarEvent {
  id: string;
  summary: string;
  start: string | null; // ISO
  end: string | null;   // ISO
  location?: string | null;
  htmlLink?: string | null;
  creator?: string | null;
  attendeesCount?: number;
}

export async function getUpcomingEvents(days = 14, max = 5): Promise<CalendarEvent[]> {
  const res = await api.get<{ success: boolean; data: CalendarEvent[] }>(`/calendar/upcoming?days=${days}&max=${max}`);
  return (res.data && (res.data as any).data) || [];
}

export default { getUpcomingEvents };


